import { PAGE_TITLES } from 'Constants/page.constants'

export const useTitle = (title: (typeof PAGE_TITLES)[keyof typeof PAGE_TITLES]) => {
    document.title = title
}
